import React, { useEffect, useState } from "react";
import Menu from "../../Components/Menu";
import Footer from "../../Components/Footer";
import { Container, Wrapper } from "./styles";
import { useParams } from "react-router";
import { db } from "../../server";
import ArticleBlock from "../../Components/ArticleBlock";

export default function Notice() {
	const { id } = useParams();
	const [noticeData, setNoticeData] = useState({});

	useEffect(() => {
		const dbRef = db.collection("noticias").doc(id);

		async function loadInfo() {
			const noticeInfo = await dbRef.get();

			if (!noticeInfo.exists) {
				return <h1>Noticia não encontrada!</h1>;
			} else {
				setNoticeData(noticeInfo.data());
			}
		}

		loadInfo();
	}, [id]);

	return (
		<>
			<Menu />
			<Container>
				<Wrapper>
					<div className="top-wrapper">
						<h1>{noticeData.title}</h1>
						<p>{noticeData.description}</p>
					</div>

					<div className="articles-wrapper">
						{!noticeData.articles ? (
							<></>
						) : (
							noticeData.articles.map((a) => <ArticleBlock data={a} />)
						)}
					</div>
				</Wrapper>
			</Container>
			<Footer />
		</>
	);
}
